import {
    put,
    call,
    takeLatest,
} from 'redux-saga/effects';
import axios from 'axios';
import { LIST_FTL_COSTS, LIST_SHIPPING_COSTS } from '../../constants/ftlCosts';
import {hideError, showErrorMessage} from "../../actions/global";
import {SERVER_FAILED_ERROR_MESSAGE} from "../../../pages/Dashboard/DashboardFinal/constants";
import { storeFTLCosts, storeShippingCosts } from '../../actions/ftlCosts';
import { FTL_COST, SHIPPING_COST } from '../../../components/global/Server/endpoints';


const getHeaders = () => {
    const token = localStorage.getItem('token');
    return {
        "Authorization": `Bearer ${token}`
    }
}

const getRequest = (endpoint) => {
    return axios.get(endpoint, {
       headers: getHeaders()
    })
        .then(response => response);
}

const postRequest = (endpoint, data) => {
    return axios.post(endpoint, data, {
        headers: getHeaders()
    })
        .then(response => response)
}

function* listFtlCostsSaga() {
    yield put(hideError())
    try {
        const response = yield call(() => getRequest(FTL_COST.LIST_FTL_COSTS))
        yield put(storeFTLCosts(response.data))
    } catch (error) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE))
    }
}

function* listShippingCostsSaga() {
    yield put(hideError())
    try {
        const response = yield call(() => getRequest(SHIPPING_COST.LIST_SHIPPING_COSTS))
        yield put(storeShippingCosts(response.data))
    } catch (error) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE))
    }
}

export default function* ftlCostsSagas() {
    yield takeLatest(LIST_FTL_COSTS, listFtlCostsSaga);
    yield takeLatest(LIST_SHIPPING_COSTS, listShippingCostsSaga);
}